import script from "./checkInventoryMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./checkInventoryMenu.vue?vue&type=script&setup=true&lang=js"

import "./checkInventoryMenu.vue?vue&type=style&index=0&id=763730b2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-763730b2"]])

export default __exports__